import { format } from 'date-fns';
import type { Timestamp } from 'firebase/firestore';

export const toMillis = (date?: Timestamp): number | undefined =>
  typeof date?.toMillis === 'function' ? date.toMillis() : undefined;

export const formatDate = (date: number | Date) => format(date, 'yyyy-MM-dd');
